import React, { useContext } from "react";
import {
  ChannelContext,
  RegionContext,
  QualityContext,
  PlayerContext,
} from "../contexts";
import "../assets/styles/quality-switch.sass";
import Utility from "../Utility";
const QualitySwitch = ({ content }) => {
  const { setUserIntent } = useContext(PlayerContext);
  const result = (
    <ChannelContext.Consumer>
      {(currentChannel) => {
        return (
          <RegionContext.Consumer>
            {(regionIndexFromContext) => {
              return (
                <QualityContext.Consumer>
                  {({ qualityIndex, setQualityIndex }) => {
                    const channel = Utility.getChannel(content, currentChannel);
                    let regionIndex = regionIndexFromContext;
                    if (
                      channel &&
                      channel.ether &&
                      channel.ether.regions &&
                      (channel.ether.regions.length <= regionIndex ||
                        !channel.ether.regions[regionIndex].qualityList)
                    ) {
                      regionIndex = 0;
                    }
                    const linksList =
                      channel &&
                      channel.ether &&
                      channel.ether.regions &&
                      channel.ether.regions.length > regionIndex &&
                      channel.ether.regions[regionIndex].qualityList &&
                      Array.isArray(
                        channel.ether.regions[regionIndex].qualityList
                      )
                        ? channel.ether.regions[regionIndex].qualityList
                        : [];
                    if (!linksList || linksList.length === 0)
                      return <div></div>;
                    return (
                      <div className="ur-mini-channel-quality-switch-wrapper">
                        {linksList.map((link, index) => (
                          <button
                            key={index}
                            onClick={() => {
                              setQualityIndex(index);
                              setUserIntent();
                            }}
                            className={
                              "ur-mini-channel-quality-button" +
                              (qualityIndex == index
                                ? " ur-mini-channel-quality-active"
                                : "")
                            }
                          >
                            {link.title}
                          </button>
                        ))}
                      </div>
                    );
                  }}
                </QualityContext.Consumer>
              );
            }}
          </RegionContext.Consumer>
        );
      }}
    </ChannelContext.Consumer>
  );
  return <>{result}</>;
};
export default QualitySwitch;
